import { runtimeConfig } from '@/config/runtime-config';
import { createCorrectGeoPathFromData } from '@/utils/SEOPathModule/utils';

type Params = {
  countryId: string;
  regionId: string;
  cityId: string;
  isWLMode?: boolean;
};

export function convertUrl(params: Params) {
  return new Promise<string>((resolve) => {
    createCorrectGeoPathFromData({
      ...params,
      updateGeo: (newPath) => {
        let defaultNoGeo = '';
        if (runtimeConfig.isMultiCountry) {
          defaultNoGeo = 'russia';
        }
        resolve(newPath || defaultNoGeo);
      },
    });
  });
}
